<template>
    <div v-if="audience?.enabled" class="audience-report">
        <h2 class="audience-report__title">Аудитория</h2>

        <div class="metrics">
            <div class="metric">
                <div class="label">Контакты у экрана</div>
                <div class="value">{{ formatOts(audience.ots) }}</div>
            </div>
            <div class="metric" v-if="audience.planned?.ots">
                <div class="label">План по настройкам</div>
                <div class="value">{{ formatOts(audience.planned.ots) }}</div>
            </div>
            <div class="metric">
                <div class="label">Данные</div>
                <div class="value value--text">{{ qualityLabel }}</div>
                <div v-if="audience.source_month" class="label">источник {{ audience.source_month }}</div>
            </div>
        </div>

        <div class="chart-card" v-if="screens.length">
            <h3>По экранам</h3>
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Экран</th>
                            <th>Контакты</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in screens" :key="row.gid">
                            <td>{{ row.gid }}</td>
                            <td>{{ formatOts(row.ots) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div
            class="chart-card"
            v-for="group in profileGroups"
            :key="group.id"
        >
            <h3>{{ group.label }}</h3>
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ group.label }}</th>
                            <th>Контакты</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in group.rows" :key="row.key">
                            <td>{{ row.label }}</td>
                            <td>{{ formatOts(row.value) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
const GROUP_ORDER = ['gender', 'age', 'income', 'interest'];

export default {
    name: 'AudienceReportCard',
    props: {
        audience: { type: Object, default: () => ({ enabled: false }) },
    },
    computed: {
        qualityLabel() {
            const q = this.audience?.quality;
            if (q === 'actual') return 'По факту выходов';
            if (q === 'projected') return 'Оценка по похожим дням';
            if (q === 'mixed') return 'Оценка и факт';
            return 'Нет данных';
        },
        screens() {
            return (this.audience?.by_gid || []).filter((row) => (Number(row.ots) || 0) > 0);
        },
        profileGroups() {
            const rows = this.audience?.profile || [];
            const byGroup = {};
            for (const row of rows) {
                const id = row.group || 'other';
                if (id === 'total') continue;
                if (id === 'interest' && !(Number(row.value) > 0)) continue;
                if (!byGroup[id]) {
                    byGroup[id] = {
                        id,
                        label: row.group_label || id,
                        rows: [],
                    };
                }
                byGroup[id].rows.push(row);
            }
            return [
                ...GROUP_ORDER.map((id) => byGroup[id]).filter((group) => group && group.rows.length > 0),
                ...Object.keys(byGroup)
                    .filter((id) => !GROUP_ORDER.includes(id))
                    .map((id) => byGroup[id])
                    .filter((group) => group && group.rows.length > 0),
            ];
        },
    },
    methods: {
        formatOts(val) {
            const n = Number(val);
            if (!Number.isFinite(n)) return '0';
            return new Intl.NumberFormat('ru-RU').format(Math.round(n));
        },
    },
};
</script>

<style scoped>
.audience-report__title {
    margin: 0 0 16px;
    font-size: 20px;
    font-weight: 600;
}

.metrics {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.metric {
    background: #fff;
    border: 1px solid #e5e7eb;
    padding: 12px;
    border-radius: 8px;
    min-width: 160px;
}

.label {
    color: #6b7280;
    font-size: 12px;
}

.value {
    font-weight: 600;
    font-size: 16px;
    margin-top: 6px;
}

.value--text {
    font-size: 14px;
}

.chart-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
}

.chart-card h3 {
    margin: 0 0 12px 0;
}

.table-wrap {
    margin-top: 12px;
    max-height: 360px;
    overflow: auto;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.table th,
.table td {
    text-align: left;
    padding: 8px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 13px;
}
</style>
